import React, { useState } from 'react';
import { decisionLogin, getDecisionApiError } from '../../services/decisionApi';
import './decision-theme.css';

export default function DecisionLoginPage({ onSuccess }) {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  async function submit(e) {
    e.preventDefault();
    setLoading(true);
    setError('');
    try {
      const data = await decisionLogin(username.trim(), password);
      if (data?.ok) {
        onSuccess();
      } else {
        setError(data?.error || '登录失败');
      }
    } catch (err) {
      setError(getDecisionApiError(err, '登录失败'));
    } finally {
      setLoading(false);
    }
  }

  return (
    <div className="login-wrap">
      <div className="login-card">
        <h1>决策分析站</h1>
        <p className="decision-muted">使用 admin 账号登录 · decision.oldox.online</p>
        <form className="login-form" onSubmit={submit}>
          <label>
            用户名
            <input
              className="decision-input"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              autoComplete="username"
            />
          </label>
          <label>
            密码
            <input
              className="decision-input"
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              autoComplete="current-password"
            />
          </label>
          {error ? <p className="decision-error">{error}</p> : null}
          <button type="submit" className="decision-btn" disabled={loading}>
            {loading ? '登录中…' : '登录'}
          </button>
        </form>
      </div>
    </div>
  );
}
